<template>

  <div>
      <v-list-item link :to="'/dashboard'">
        <v-list-item-icon>
          <v-icon>mdi-view-dashboard</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Dashboard</v-list-item-title>
      </v-list-item>
    <v-subheader>Reserve</v-subheader>
        <v-list-item link :to="'/reserve'">
          <v-list-item-icon>
            <v-icon>mdi-calendar-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>New Reservation</v-list-item-title>
        </v-list-item>
        <!-- <v-list-item link :to="'/reserve2'">
          <v-list-item-icon>
            <v-icon>mdi-calendar-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Reserve</v-list-item-title>
        </v-list-item> -->
        <v-list-item link :to="'/reservations/my'">
          <v-list-item-icon>
            <v-icon>mdi-calendar-account</v-icon>
          </v-list-item-icon>
          <v-list-item-title>My Reservations</v-list-item-title>
        </v-list-item>
    <!-- <v-subheader>Settings</v-subheader>
        <v-list-item link :to="'/settings'">
          <v-list-item-icon>
            <v-icon>mdi-cog</v-icon>
          </v-list-item-icon>
          <v-list-item-title>My Settings</v-list-item-title>
        </v-list-item> -->
  </div>
</template>

<script>

export default {
  name: 'MitMenuUser',
  components: {
  },
  props: {
    userModel: Object
  },
  data() {
    return {
    }
  },
  created() {
  }

}
</script>

<style lang="scss" scoped>
</style>
